import React from "react";
import { Routes, Route } from "react-router-dom";
import PublicRoute from "../auth/PublicRoute";
import AuthLayout from "../pages/auth/loginForm/AuthLayout";
import Forgot_Password from "../pages/auth/loginForm/Forgot_Password";
import Password_Reset from "../pages/auth/loginForm/Password_Reset";
import Password_Success from "../pages/auth/loginForm/Password_Success";
import LoginForm from "../pages/auth/loginForm/LoginForm";
import VerificationPage from "../pages/auth/loginForm/verificationPage";
import MailVerificationPage from "../pages/auth/loginForm/mailVerificationPage";
import Calendario from "../pages/calendario/Calendario";
import Contatti from "../component/Contatti/Contatti";
import Relazioni from "../component/table/Relazioni/Relazioni";
import Qualificazione from "../component/Qualificazione/Qualificazione";
import ReactBigCalendar from "../component/calendar/Calendar";
import Allegati from "../component/table/Allegati/Allegati";
import Dati from "../component/Dati/Dati";
import Sedi from "../component/Sedi/Sedi";
import Documenti from "../component/Documenti/Documenti";
import Turni from "../component/Turni/Turni.jsx";
import Progetti from "../component/Progetti/Progetti.jsx";
import Contratto from "../component/Contratto/Contratto.jsx";
import ConfigureDetails from "../pages/Production/Configure.jsx";
import HrContatti from "../component/Contatti/HrContatti";
import HrQualificazione from "../component/Qualificazione/HrQualificazione.jsx";
import Plan from "../pages/Production/Plan.jsx";
import Productions from "../pages/Production/Productions.jsx";
import ProductionsDetails from "../pages/Production/ProductionsDetails.jsx";
import Processes from "../pages/Production/Processes.jsx";
import ProcessesDetails from "../pages/Production/ProcessesDetails.jsx";
import Archive from "../pages/Production/Archive.jsx";
import SubLeadAnagrafiche from "../pages/Anagrafiche/Lead/subLead/SubLeadAnagrafiche.jsx";
import CandidatiAnagrafiche from "../pages/Anagrafiche/Candidati/CandidatiAnagrafiche.jsx";
import CandidatoAnagrafiche from "../pages/Anagrafiche/Candidati/CandidatoAnagrafiche.jsx";
import ColaboratoryAnagrafiche from "../pages/Anagrafiche/Colaboratory/ColaboratoryAnagrafiche.jsx";
import SubColaboratoryAnagrafiche from "../pages/Anagrafiche/Colaboratory/SubColaboratory.jsx";
import FornitoriAnagrafiche from "../pages/Anagrafiche/Fornitori/FornitoriAnagrafiche.jsx";
import DettaglioAnagrafiche from "../pages/Anagrafiche/Fornitori/Dettaglio/DettaglioAnagrafiche.jsx";
import ClientiAnagrafiche from "../pages/Anagrafiche/Clienti/ClientiAnagrafiche.jsx";
import DettaglioClientiAnagrafiche from "../pages/Anagrafiche/Clienti/Dettaglio/DettaglioClientiAnagrafiche.jsx";
import ArchiveDetails from "../pages/Production/ArchiveDetails.jsx";
import ProdottiAnagrafiche from "../pages/Anagrafiche/Prodotti/ProdottiAnagrafiche.jsx";
import AttrezzatureAnagrafiche from "../pages/Anagrafiche/Attrezzature/AttrezzatureAnagrafiche.jsx";
import MezziAnagrafiche from "../pages/Anagrafiche/Mezzi/MezziAnagrafiche.jsx";
import SensoriAnagrafiche from "../pages/Anagrafiche/Sensori/SensoriAnagrafiche.jsx";
import LottiAnagrafiche from "../pages/Anagrafiche/Lotti/LottiAnagrafiche.jsx";
import StabilimentiAnagrafiche from "../pages/Anagrafiche/Stabilimenti/StabilimentiAnagrafiche.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import Cantine from "../pages/structure/Cantine/Cantine.jsx";
import Terreni from "../pages/structure/Terreni/Terreni.jsx";
import Stabilimenti from "../pages/structure/Stabilimenti/Stabilimenti.jsx";
import Prodotti from "../pages/structure/Prodotti/Prodotti.jsx";
import Sensori from "../pages/structure/Sensori/Sensori.jsx";
import SubCantine from "../pages/structure/Cantine/SubCantine.jsx";
import SubTerreni from "../pages/structure/Cantine/SubTerreni.jsx";
import SubStabilimenti from "../pages/structure/Cantine/SubStabilimenti.jsx";
import SubProdotti from "../pages/structure/Cantine/SubProdotti.jsx";
import SubMezzi from "../pages/structure/Cantine/SubMezzi.jsx";
import SubParticelle from "../pages/structure/Terreni/SubParticelle.jsx";
import SubStrucutureTerreni from "../pages/structure/Terreni/SubStrucutureTerreni.jsx";
import SubSensori from "../pages/structure/Terreni/SubSensori.jsx";
import SubTrattamenti from "../pages/structure/Terreni/SubTrattamenti.jsx";
import SubStructureStabiliment from "../pages/structure/Stabilimenti/SubStructureStabiliment.jsx";
import SubAttrezzature from "../pages/structure/Stabilimenti/SubAttrezzature.jsx";
import SubStructureSensori from "../pages/structure/Stabilimenti/SubStructureSensori.jsx";
import SubStructureGiacenze from "../pages/structure/Stabilimenti/SubStructureGiacenze.jsx";
import SubStrucutureProdotti from "../pages/structure/Prodotti/SubStrucutureProdotti.jsx";
import StructureSensori from "../pages/structure/Sensori/StructureSensori.jsx";
import Produzioni from "../pages/Produzione/produzioni/Produzioni.jsx";
import Trattamenti from "../pages/Produzione/trattamenti/Trattamenti.jsx";
import Archivio from "../pages/Produzione/archivio/Archivio.jsx";
import Ricette from "../pages/Produzione/ricette/Ricette.jsx";
import Fasi from "../pages/Produzione/ricette/Fasi.jsx";
import SubProduzioni from "../pages/Produzione/produzioni/SubProduzioni.jsx";
import SubStabilimentiLogistica from "../pages/Logistica/Stabilimenti/SubStabilimentiLogistica.jsx";
import SublogisticaAttrezzature from "../pages/Logistica/Stabilimenti/SublogisticaAttrezzature.jsx";
import SubLogisticaSensori from "../pages/Logistica/Stabilimenti/SubLogisticaSensori.jsx";
import SubLogisticaGiacenze from "../pages/Logistica/Stabilimenti/SubLogisticaGiacenze.jsx";
import TrasportoLogistica from "../pages/Logistica/Trasporto/TrasportoLogistica.jsx";
import SubTrasporto from "../pages/Logistica/Trasporto/SubTrasporto.jsx";
import MezziLogistica from "../pages/Logistica/Mezzi/MezziLogistica.jsx";
import SubMezziLogistica from "../pages/Logistica/Mezzi/SubMezziLogistica.jsx";
import Manutenzione from "../pages/Logistica/Mezzi/Manutenzione.jsx";
import DocumentiMezzi from "../pages/Logistica/Mezzi/DocumentiMezzi.jsx";
import SensoriMezzi from "../pages/Logistica/Mezzi/SensoriMezzi.jsx";
import ViaggiMezzi from "../pages/Logistica/Mezzi/ViaggiMezzi.jsx";
import StabilimentiLogistica from "../pages/Logistica/Stabilimenti/StabilimentiLogistica.jsx";
import PrivateRoute from "../auth/PrivateRoute.jsx";
import LocationTable from "../pages/structure/Sensori/LocationTable.jsx";
import Operatori from "../pages/structure/Operatori/Operatori.jsx";
// import SubStrucutureProdotti from "../pages/structure/Prodotti/SubStrucutureProdotti.jsx";
// import SubAttrezzature from "../pages/structure/Prodotti/SubAttrezzature.jsx";

const Allroutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PublicRoute>
            <AuthLayout Component={LoginForm} />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <AuthLayout Component={Forgot_Password} />
          </PublicRoute>
        }
      />
      <Route
        path="/password-reset"
        element={
          <PublicRoute>
            <AuthLayout Component={Password_Reset} />
          </PublicRoute>
        }
      />
      <Route
        path="/password-success"
        element={
          <PublicRoute>
            <AuthLayout Component={Password_Success} />
          </PublicRoute>
        }
      />
      <Route
        path="/verification"
        element={
          <PublicRoute>
            <AuthLayout Component={VerificationPage} />
          </PublicRoute>
        }
      />
      <Route
        path="/mail-verification"
        element={
          <PublicRoute>
            <AuthLayout Component={MailVerificationPage} />
          </PublicRoute>
        }
      />
      <Route
        path="/calendar"
        element={
          <PublicRoute>
            <Calendario />
          </PublicRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/example"
        element={
          <PrivateRoute>
            <Relazioni />
          </PrivateRoute>
        }
      />
      {/* Newly added routes */}

      <Route
        path="/strutture/cantine"
        element={
          <PrivateRoute>
            <Cantine />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/terreni"
        element={
          <PrivateRoute>
            <Terreni />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/stabilimenti"
        element={
          <PrivateRoute>
            <Stabilimenti />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/prodotti"
        element={
          <PrivateRoute>
            <Prodotti />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/prodotti/Giacenze"
        element={
          <PrivateRoute>
            <SubStrucutureProdotti Component={SubStructureGiacenze} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/sensori"
        element={
          <PrivateRoute>
            <Sensori />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/cantine/Terreni"
        element={
          <PrivateRoute>
            <SubCantine Component={SubTerreni} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/cantine/Stabilimenti"
        element={
          <PrivateRoute>
            <SubCantine Component={SubStabilimenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/cantine/Prodotti"
        element={
          <PrivateRoute>
            <SubCantine Component={SubProdotti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/cantine/Mezzi"
        element={
          <PrivateRoute>
            <SubCantine Component={SubMezzi} />
          </PrivateRoute>
        }
      />

      <Route
        path="/strutture/terreni/Particelle"
        element={
          <PrivateRoute>
            <SubStrucutureTerreni Component={SubParticelle} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/terreni/Sensori"
        element={
          <PrivateRoute>
            <SubStrucutureTerreni Component={SubSensori} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/terreni/Trattamenti"
        element={
          <PrivateRoute>
            <SubStrucutureTerreni Component={SubTrattamenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/stabiliment/Attrezzature"
        element={
          <PrivateRoute>
            <SubStructureStabiliment Component={SubAttrezzature} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/stabiliment/Sensori"
        element={
          <PrivateRoute>
            <SubStructureStabiliment Component={SubStructureSensori} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/stabiliment/Giacenze"
        element={
          <PrivateRoute>
            <SubStructureStabiliment Component={SubStructureGiacenze} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/sensori/Location/Oggi"
        element={
          <PrivateRoute>
            <StructureSensori Component={LocationTable} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/sensori/Location/ultima_settimana"
        element={
          <PrivateRoute>
            <StructureSensori Component={LocationTable} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/sensori/Location/ultimo_mese"
        element={
          <PrivateRoute>
            <StructureSensori Component={LocationTable} />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/sensori/Location/Archivio"
        element={
          <PrivateRoute>
            <StructureSensori Ricette Component={LocationTable} />
          </PrivateRoute>
        }
      />

      <Route
        path="/strutture/sensori/Location"
        element={
          <PrivateRoute>
            <StructureSensori />
          </PrivateRoute>
        }
      />
      <Route
        path="/strutture/operatori"
        element={
          <PublicRoute>
            <Operatori />
          </PublicRoute>
        }
      />

      <Route
        path="/produzione/produzioni"
        element={
          <PrivateRoute>
            <Produzioni />
          </PrivateRoute>
        }
      />

      <Route
        path="/produzione/vendemmia"
        element={
          <PrivateRoute>
            <SubProduzioni />
          </PrivateRoute>
        }
      />

      <Route
        path="/produzione/trattamenti"
        element={
          <PrivateRoute>
            <Trattamenti />
          </PrivateRoute>
        }
      />
      <Route
        path="/produzione/archivio"
        element={
          <PrivateRoute>
            <Archivio />
          </PrivateRoute>
        }
      />

      <Route
        path="/produzione/ricette/Fasi"
        element={
          <PrivateRoute>
            <Ricette Component={Fasi} />
          </PrivateRoute>
        }
      />
      <Route
        path="/produzione/ricette/"
        element={
          <PrivateRoute>
            <Ricette Component={SubStructureSensori} />
          </PrivateRoute>
        }
      />
      <Route
        path="/produzione/ricette/"
        element={
          <PrivateRoute>
            <Ricette Component={SubStructureGiacenze} />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/stabilimenti"
        element={
          <PrivateRoute>
            <StabilimentiLogistica />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/stabilimenti/Attrezzature"
        element={
          <PrivateRoute>
            <SubStabilimentiLogistica Component={SublogisticaAttrezzature} />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/stabilimenti/Sensori"
        element={
          <PrivateRoute>
            <SubStabilimentiLogistica Component={SubLogisticaSensori} />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/stabilimenti/Giacenze"
        element={
          <PrivateRoute>
            <SubStabilimentiLogistica Component={SubStructureGiacenze} />
          </PrivateRoute>
        }
      />

      <Route
        path="/logistica/trasporto"
        element={
          <PrivateRoute>
            <TrasportoLogistica />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/trasporto/graph"
        element={
          <PrivateRoute>
            <SubTrasporto />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/mezzi"
        element={
          <PrivateRoute>
            <MezziLogistica />
          </PrivateRoute>
        }
      />

      <Route
        path="/logistica/mezzi/Manutenzione"
        element={
          <PrivateRoute>
            <SubMezziLogistica Component={Manutenzione} />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/mezzi/Documenti"
        element={
          <PrivateRoute>
            <SubMezziLogistica Component={DocumentiMezzi} />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/mezzi/Sensori"
        element={
          <PrivateRoute>
            <SubMezziLogistica Component={SensoriMezzi} />
          </PrivateRoute>
        }
      />
      <Route
        path="/logistica/mezzi/Viaggi"
        element={
          <PrivateRoute>
            <SubMezziLogistica Component={ViaggiMezzi} />
          </PrivateRoute>
        }
      />

      {/* previous */}

      <Route
        path="/production/processes/details"
        element={
          <PrivateRoute>
            <ProcessesDetails Component={ConfigureDetails} />
          </PrivateRoute>
        }
      />

      <Route
        path="/production/archive"
        element={
          <PrivateRoute>
            <Archive />
          </PrivateRoute>
        }
      />


      <Route
        path="/angrafiche/prodotti"
        element={
          <PrivateRoute>
            <ProdottiAnagrafiche />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/attrezzature"
        element={
          <PrivateRoute>
            <AttrezzatureAnagrafiche />
          </PrivateRoute>
        }
      />

      <Route
        path="/angrafiche/mezzi"
        element={
          <PrivateRoute>
            <MezziAnagrafiche />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sensori"
        element={
          <PrivateRoute>
            <Sensori />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/stabilimenti"
        element={
          <PrivateRoute>
            <StabilimentiAnagrafiche />
          </PrivateRoute>
        }
      />
      {/*      <Route
        path="/angrafiche/stabilimenti/Gaicenze"
        element={
          <PrivateRoute>
            <SubStabilimentiAnagrafiche Component={GiacenzeStabilimenti} />
          </PrivateRoute>
        }
      /> */}
      {/* <Route
        path="/angrafiche/stabilimenti/Mezzi"
        element={
          <PrivateRoute>
            <SubStabilimenti Component={MezziStabiliment} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/stabilimenti/Attrezzature"
        element={
          <PrivateRoute>
            <SubStabilimenti Component={AttrezzatureStablimenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/stabilimenti/Collaboratori"
        element={
          <PublicRoute>
            <SubStabilimenti Component={CollaboratoriStablimenti} />
          </PublicRoute>
        }
      />
      <Route
        path="/angrafiche/stabilimenti/Contatti"
        element={
          <PublicRoute>
            <SubStabilimenti Component={Contatti} />
          </PublicRoute>
        }
      /> */}
      <Route
        path="/angrafiche/lotti"
        element={
          <PrivateRoute>
            <LottiAnagrafiche />
          </PrivateRoute>
        }
      />
      {/*      <Route
        path="/angrafiche/lead"
        element={
          <PrivateRoute>
            <LeadAnagrafiche />
          </PrivateRoute>
        }
      /> */}
      <Route
        path="/anagrafiche/sub-lead/Contatti"
        element={
          <PrivateRoute>
            <SubLeadAnagrafiche Component={Contatti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/anagrafiche/sub-lead/Qualificazione"
        element={
          <PrivateRoute>
            <SubLeadAnagrafiche Component={Qualificazione} />
          </PrivateRoute>
        }
      />
      <Route
        path="/anagrafiche/sub-lead/Documenti"
        element={
          <PrivateRoute>
            <SubLeadAnagrafiche Component={Documenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/anagrafiche/sub-lead/Agenda"
        element={
          <PrivateRoute>
            <SubLeadAnagrafiche Component={ReactBigCalendar} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/candidati"
        element={
          <PrivateRoute>
            <CandidatiAnagrafiche />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/candidati/Contatti"
        element={
          <PrivateRoute>
            <CandidatoAnagrafiche Component={HrContatti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/candidati/Qualificazione"
        element={
          <PrivateRoute>
            <CandidatoAnagrafiche Component={HrQualificazione} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/candidati/Agenda"
        element={
          <PrivateRoute>
            <CandidatoAnagrafiche Component={ReactBigCalendar} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/candidati/Allegati"
        element={
          <PrivateRoute>
            <CandidatoAnagrafiche Component={Allegati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/candidati/Allegati"
        element={
          <PrivateRoute>
            <CandidatoAnagrafiche Component={Allegati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/colaboratory"
        element={
          <PrivateRoute>
            <ColaboratoryAnagrafiche />
          </PrivateRoute>
        }
        ColaboratoryAnagrafiche
      />
      <Route
        path="/angrafiche/sub-colaboratory/Contatti"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={HrContatti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Qualificazione"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={HrQualificazione} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Documenti"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={Documenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Contratto"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={Contratto} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Equipagiamento"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={Documenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Turni"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={Turni} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Progetti"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={Progetti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Agenda"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={ReactBigCalendar} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/sub-colaboratory/Allegati"
        element={
          <PrivateRoute>
            <SubColaboratoryAnagrafiche Component={Allegati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori"
        element={
          <PrivateRoute>
            <FornitoriAnagrafiche />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Contatti"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Contatti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Qualificazione"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Qualificazione} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Documenti"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Documenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Agenda"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={ReactBigCalendar} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Dati"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Dati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Sedi"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Sedi} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Relazioni"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Relazioni} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/fornitori/Allegati"
        element={
          <PrivateRoute>
            <DettaglioAnagrafiche Component={Allegati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti"
        element={
          <PrivateRoute>
            <ClientiAnagrafiche />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Contatti"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Contatti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Qualificazione"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Qualificazione} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Documenti"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Documenti} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Agenda"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={ReactBigCalendar} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Dati"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Dati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Sedi"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Sedi} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Relazioni"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Relazioni} />
          </PrivateRoute>
        }
      />
      <Route
        path="/angrafiche/clienti/Allegati"
        element={
          <PrivateRoute>
            <DettaglioClientiAnagrafiche Component={Allegati} />
          </PrivateRoute>
        }
      />
      <Route
        path="/production/archive/details"
        element={
          <PrivateRoute>
            <ArchiveDetails />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default Allroutes;
